import { Injectable, inject } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { catchError, of, shareReplay } from "rxjs";

import { AttioClient, AttioWorkspace } from "src/api-service";

/**
 * The Attio workspace Core is connected to. The API reads it from Core's Attio API key, so links into Attio open
 * the environment's own workspace. Loaded once, when a page first needs a link.
 */
@Injectable({ providedIn: "root" })
export class AttioWorkspaceService {

    // =========================================================================
    // DEPENDENCY INJECTION
    // =========================================================================
    private readonly attioClient = inject(AttioClient);

    // =========================================================================
    // STATE
    // =========================================================================
    /** Null until loaded, and when it can't be read: the links into Attio are then left out. */
    public readonly workspace = toSignal(
        this.attioClient.getWorkspace().pipe(
            catchError(() => of(null as AttioWorkspace | null)),
            shareReplay(1),
        ),
        { initialValue: null },
    );
}
